module.exports = __webpack_public_path__ + "../resources/img/ic-re-inverter-default.e4d9b63b.svg";